export const borderlessButtonStyle = {
  outline: 'transparent',
  background: 'transparent',
  padding: '0px',
};
